module.exports = __webpack_public_path__ + "static/media/design_03.ff4c684e.png";